import { logInLogoIcon } from "../assets";


export const colorOptions = [
    { value: '#1976d2', label: 'Royal Blue', class: 'primary' },
    { value: '#dc004e', label: 'Rose Pink', class: 'secondary' },
    { value: '#4caf50', label: 'Forest Green', class: 'success' },
    { value: '#ff9800', label: 'Sunset Orange', class: 'warning' },
    { value: '#f44336', label: 'Crimson Red', class: 'error' },
    { value: '#9c27b0', label: 'Deep Purple', class: 'purple' },
    { value: '#00bcd4', label: 'Ocean Cyan', class: 'cyan' },
    { value: '#795548', label: 'Warm Brown', class: 'brown' },
    { value: '#607d8b', label: 'Steel Blue', class: 'blue-grey' },
    { value: '#e91e63', label: 'Fuchsia Pink', class: 'pink' },
    { value: '#009688', label: 'Teal Green', class: 'teal' },
    { value: '#ffc107', label: 'Golden Amber', class: 'golden' },
    { value: '#3f51b5', label: 'Indigo', class: 'indigo' },
    { value: '#ff5722', label: 'Burnt Orange', class: 'burnt-orange' },
    { value: '#8bc34a', label: 'Lime Green', class: 'lime' },
];





export const companyInfo = {
        name: "SJC",
        address: "Apac District",
        phone: "0701243139",
        email: "hotel@gmail.com",
        logo: logInLogoIcon,
        website: "www.hotel.com",
        receiptFooter: "Thank you for your business! Please come again."
    };



export const developerInfo = {
        name: "mogasoft",
        package: "SJC",
        webSite: "www.mogasoft.com",
        version: "1.0.0"
    };